<template>
  <div class="container mt-4">
    <div class="row justify-content-center">
      <div class="col-12 col-md-9 col-lg-7">
        <h1 class="font-weight-light text-center">Add a Meeting</h1>
        <div class="col-12 alert alert-danger px-3" v-if="errorMessage">
          {{ errorMessage }}
        </div>
        <div class="card bg-light">
          <div class="card-body text-center">
            <form class="formgroup">
              <div class="input-group input-group-lg">
                <input
                  type="text"
                  class="form-control"
                  name="meetingName"
                  placeholder="Name"
                  aria-describedby="buttonAdd"
                  v-model="meetingName"
                  ref="meetingName"
                />
                <input
                  type="text"
                  class="form-control"
                  name="meetingDate"
                  placeholder="Date"
                  aria-describedby="buttonAdd"
                  v-model="meetingDate"
                  ref="meetingDate"
                />
                <input
                  type="text"
                  class="form-control"
                  name="meetingTime"
                  placeholder="Time"
                  aria-describedby="buttonAdd"
                  v-model="meetingTime"
                  ref="meetingTime"
                />
                <input
                  type="text"
                  class="form-control"
                  name="meetingPlace"
                  placeholder="Place"
                  aria-describedby="buttonAdd"
                  v-model="meetingPlace"
                  ref="meetingPlace"
                />
                <div class="input-group-append">
                  <button
                    type="submit"
                    class="btn btn-sm btn-primary"
                    id="buttonAdd"
                    @click.prevent="handleAddMeeting"
                  >
                    +
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-11 col-md-8 col-lg-6">
        <div class="card border-top-0 rounded-0">
          <div class="card-body py-2">
            <h4 class="card-title m-0 text-center">Your Meetings</h4>
          </div>
          <div class="list-group list-group-flush">
            <div
              class="list-group-item d-flex"
              v-for="item in meetings"
              :key="item.id"
            >
              <section
                class="btn-group align-self-center"
                role="group"
                aria-label="Meeting Options"
              >
                <button
                  class="btn btn-sm btn-outline-secondary bg-light"
                  title="Delete Meeting"
                  @click="$emit('deleteMeeting', item.id)"
                >
                  <font-awesome-icon
                    class="text-danger"
                    icon="trash"
                  ></font-awesome-icon>
                </button>

                <router-link
                  class="btn btn-sm btn-outline-secondary bg-light"
                  title="Check In"
                  :to="'/checkin/' + user.uid + '/' + item.id"
                >
                  <font-awesome-icon icon="link"></font-awesome-icon>
                </router-link>

                <router-link
                  class="btn btn-sm btn-outline-secondary bg-light"
                  title="Attendees"
                  :to="'/attendees/' + user.uid + '/' + item.id"
                >
                  <font-awesome-icon icon="list-ul"></font-awesome-icon>
                </router-link>
              </section>
              <section class="pl-3 text-left align-self-center">
                {{ item.name }}
              </section>
              <section class="pl-3 text-left align-self-center">
                {{ item.date }}
              </section>
              <section class="pl-3 text-left align-self-center">
                {{ item.time }}
              </section>
              <section class="pl-3 text-left align-self-center">
                {{ item.place }}
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
export default {
  name: "meetings",
  components: {
    FontAwesomeIcon
  },
  data: function() {
    return {
      meetingName: null,
      meetingDate: null,
      meetingTime: null,
      meetingPlace: null,
      errorMessage: null
    };
  },
  methods: {
    handleAddMeeting: function() {
      if (!this.meetingName) {
        this.errorMessage = "Meeting name is required";
        return;
      }
      this.$emit("addMeeting", {
        name: this.meetingName,
        date: this.meetingDate,
        time: this.meetingTime,
        place: this.meetingPlace
      });
      this.meetingName = null;
      this.meetingDate = null;
      this.meetingTime = null;
      this.meetingPlace = null;
      this.$refs.meetingName.focus();
    }
  },
  mounted() {
    if (this.user && this.user.uid) {
      // Continue
    } else {
      this.$router.push("/login");
    }
  },
  props: ["user", "meetings"]
};
</script>
